import React from "react"
import ScrollIcon from "../../assets/scroll.png"
import "./BouncingIcon.css"

const BouncingIcon = () => {
  return (
    <>
      <img className="animated absolute left-0 right-0 z-2 center" src={ScrollIcon} style={{ width: "215px", height: "143px" }} alt="scroll down icon" />
    </>
  )
}

export default BouncingIcon
